import axios from 'axios';
import config from '../config';
import { requestHeaders, handleResponse } from '../helpers';
import { authHeader } from '../helpers/auth-headers';

export const ideaConclusionService = {
  sendConclusionIdea,
  cancelConclusionIdea, 
  uploadFiles
};


function sendConclusionIdea(id, conclusion) {
  return axios
    .put(
      `${config.URL_BASE}/ideas/${id}/finishexecution`,
      conclusion,
      requestHeaders()
    )
    .then(handleResponse);
}

function cancelConclusionIdea(id, cancel) {
  return axios
    .put(
      `${config.URL_BASE}/ideas/${id}/cancelexecution`,
      cancel,
      requestHeaders()
    )
    .then(handleResponse);
}
function uploadFiles(type, files, ideaId) {
  const promises = files.map((file) => {
    const data = new FormData();
    data.append(type, file.file, file.name);
    return axios.post(`${config.URL_BASE}/uploads/idea/${ideaId}`, data, {
      headers: authHeader(),
    });
  });
  return Promise.all(promises);
}